import { Vector2 } from "../../common/vector2.js";
import { Easing } from "../../transforms/transform_base.js";
import { TransformScale } from "../../transforms/transform_scale.js";
import { UIElement } from "./ui_element.js";

const CANNONS_PULSE_SCALE = 1.15;
const CANNONS_PULSE_DELAY_MS = 120;
const CANNONS_PULSE_UP_MS = 110;
const CANNONS_PULSE_DOWN_MS = 140;

export function pulseCannons( cannons: UIElement ): void
{
  const start = performance.now() + CANNONS_PULSE_DELAY_MS;
  const rest = new Vector2( 1, 1 );
  const peak = new Vector2( CANNONS_PULSE_SCALE, CANNONS_PULSE_SCALE );
  const settle_start = start + CANNONS_PULSE_UP_MS;

  cannons.addTransform( new TransformScale(
    cannons, true, rest, peak, start, CANNONS_PULSE_UP_MS, { easing: Easing.EaseOutQuad }
  ) );
  cannons.addTransform( new TransformScale(
    cannons, true, peak, rest, settle_start, CANNONS_PULSE_DOWN_MS, { easing: Easing.EaseInOutQuad }
  ) );
}
